import { render, staticRenderFns } from "./IssueSolutionList.vue?vue&type=template&id=44d24f76&scoped=true"
import script from "./IssueSolutionList.vue?vue&type=script&lang=js"
export * from "./IssueSolutionList.vue?vue&type=script&lang=js"
import style0 from "./IssueSolutionList.vue?vue&type=style&index=0&id=44d24f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d24f76",
  null
  
)

export default component.exports